import React from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { ContentZonesService, WindowProxy } from '@sm360/widget-commons-core-services';
import { MEDIA_QUERIES } from '@sm360/widget-commons-general';
import { Quote } from '@sm360/widget-commons-vehicle';

import 'trade-in/components/InstantEstimate/InstantEstimate.scss';
import InstantEstimateIcon from 'trade-in/components/InstantEstimate/InstantEstimateIcon.jsx';
import InstantEstimateAutocomplete from 'trade-in/components/InstantEstimate/InstantEstimateAutocomplete.jsx';
import NewInstantEstimateAutocomplete from 'trade-in/components/InstantEstimate/NewInstantEstimateAutocomplete.jsx';

import InstantEstimateModal from 'trade-in/components/InstantEstimateModal/InstantEstimateModal.jsx';
import OfficialTradeInModal from 'trade-in/components/OfficialTradeInModal/OfficialTradeInModal.jsx';

import NewTradeInContext from '../../NewTradeInContext';

class InstantEstimate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEstimateTradeInModalOpen: false,
            isOfficialTradeInModalOpen: false,
            tradeInVehicle: {},
            inputValue: '',
            componentWasMounted: false,
        };
        this.onValueSelected = this.onValueSelected.bind(this);
        this.getParentSize = this.getParentSize.bind(this);
        this.getClassNameFromParentSize = this.getClassNameFromParentSize.bind(this);
        this.handleCloseEstimate = this.handleCloseEstimate.bind(this);
        this.handleCloseOfficial = this.handleCloseOfficial.bind(this);
        this.handleResize = debounce(() => this.forceUpdate(), 150).bind(this);
    }

    componentWillMount() {
        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            windowProxy.addEventListener('resize', this.handleResize);
        }
    }

    componentDidMount() {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ componentWasMounted: true });
    }

    componentWillUnmount() {
        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            windowProxy.removeEventListener('resize', this.handleResize);
        }
    }

    onValueSelected(inputValue, selectedValue) {
        this.setState({
            inputValue,
            isEstimateTradeInModalOpen: !!selectedValue,
            tradeInVehicle: selectedValue || {},
        });
        // TODO: need 1 news params on the func. "handler" and need to setState : tradeInVehicle as selectedValue
    }

    getParentSize() {
        const windowProxy = WindowProxy.get();
        if (!windowProxy) {
            return null;
        }
        const parent = windowProxy.document.getElementById(this.props.parentElementId);
        if (!parent) {
            return null;
        }
        return parent.offsetWidth;
    }

    getClassNameFromParentSize() {
        const size = this.getParentSize();
        if (!size) {
            return '';
        }
        if (size <= MEDIA_QUERIES.MOBILE.MAX) {
            return 'instant-estimate-mobile';
        }
        if (size >= MEDIA_QUERIES.TABLET.MIN && size <= MEDIA_QUERIES.TABLET.MAX) {
            return 'instant-estimate-tablet';
        }
        return '';
    }

    static contextType = NewTradeInContext;

    handleCloseEstimate() {
        this.setState({ isEstimateTradeInModalOpen: false });
    }

    handleCloseOfficial() {
        this.setState({ isOfficialTradeInModalOpen: false });
    }

    render() {
        const czGroup = 'widget.tradein.teaser';
        const styleBackgroundPrimary = {
            backgroundColor: ContentZonesService.getContentZone(czGroup, 'primary.background.color')
                ? ContentZonesService.getContentZone(czGroup, 'primary.background.color').getValue()
                : '#21232e',
        };
        const stylePatternOverlay = {
            backgroundImage:
                ContentZonesService.getContentZone(czGroup, 'pattern') &&
                `url(${ContentZonesService.getContentZone(czGroup, 'pattern').getValue()})`,
        };

        // important: classNames between server render and client render must match at first
        // for react hydration to work properly
        let classNames = 'instant-estimate__showroom';

        if (this.state.componentWasMounted) {
            classNames = `${classNames} ${this.getClassNameFromParentSize()}`.trim();
        }

        return (
            <div className={classNames} style={styleBackgroundPrimary}>
                <div
                    className={`${
                        this.context.displayNewTradeIn ? 'new-instant-estimate__wrapper' : ''
                    } instant-estimate__wrapper`}
                >
                    <InstantEstimateIcon />
                    {this.context.displayNewTradeIn ? (
                        <NewInstantEstimateAutocomplete
                            onAutoCompleteSelect={this.onValueSelected}
                            selectedValue={this.state.inputValue}
                            parentClassName={this.getClassNameFromParentSize()}
                        />
                    ) : (
                        <InstantEstimateAutocomplete
                            onAutoCompleteSelect={this.onValueSelected}
                            selectedValue={this.state.inputValue}
                            parentClassName={this.getClassNameFromParentSize()}
                        />
                    )}
                    {stylePatternOverlay.backgroundImage && (
                        <div role="img" className="instant-estimate__pattern" style={stylePatternOverlay} />
                    )}
                </div>
                <InstantEstimateModal
                    openModal={this.state.isEstimateTradeInModalOpen}
                    onClose={this.handleCloseEstimate}
                    tradeInVehicle={this.state.tradeInVehicle}
                    isShowroomV2Enabled={this.props.isShowroomV2Enabled}
                    quote={this.props.quote}
                    // TODO: newTradeIn - Remove prop isDisplayNewTradeIn after deploy new tradeIn to the PROD
                    isDisplayNewTradeIn={this.context.displayNewTradeIn}
                />
                <OfficialTradeInModal
                    openModal={this.state.isOfficialTradeInModalOpen}
                    onClose={this.handleCloseOfficial}
                    tradeInVehicle={this.state.tradeInVehicle}
                    quote={this.props.quote}
                />
            </div>
        );
    }
}

InstantEstimate.displayName = 'InstantEstimate';

InstantEstimate.propTypes = {
    isShowroomV2Enabled: PropTypes.bool.isRequired,
    parentElementId: PropTypes.string.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
};

export default InstantEstimate;
